import api from '@/infra/api'

import apiCallHandler from './apiCallHandler'

export const getCreditBalance = (companyId) => {
  return apiCallHandler(() => api.get(`/companies-service/${companyId}/wallet/balance`))
}
